import { AppDataActions, AppDataSelectors } from '../../redux/app-data';
import { WSMessage } from './ws-message';

/**
 * @property {KEventRemovedMessage} message
 */
export class EventRemovedMessage extends WSMessage {
  isRelevant(state) {
    const { eventId } = this.message.er;
    const eventsMap = AppDataSelectors.selectEventsMap(state);

    if (eventId in eventsMap && eventsMap[eventId]) {
      this.actions.push(AppDataActions.removeEvent(this.message.er.eventId));
      return true;
    }

    return false;
  }
}
